// SegmentedTabs v2 — connected segmented control per the calibration sheet.
// One bordered group; segments share internal dividers. Active: blue600 + white.
// Inactive: white surface, ink text, weight 500. Radius on the group, not each segment.
import React from 'react';
import { tokens } from '../theme';

export default function SegmentedTabs({ tabs, active, onChange, size = 'md', style }) {
  const pad = size === 'sm' ? '6px 13px' : '7px 15px';
  const fs = 14;
  return (
    <div style={{ display: 'inline-flex', flexWrap: 'wrap',
      border: '1px solid ' + tokens.border, borderRadius: 8, overflow: 'hidden',
      background: tokens.surface, ...style }}>
      {tabs.map(([k, label], i) => {
        const on = active === k;
        return (
          <button key={k} onClick={() => onChange(k)}
            onMouseEnter={e => { if (!on) e.currentTarget.style.background = tokens.aiSoft; }}
            onMouseLeave={e => { if (!on) e.currentTarget.style.background = tokens.surface; }}
            style={{
              padding: pad, fontSize: fs, fontWeight: 500, fontFamily: tokens.font,
              cursor: 'pointer', whiteSpace: 'nowrap', border: 'none',
              borderLeft: i === 0 ? 'none' : '1px solid ' + tokens.borderSoft,
              background: on ? tokens.ai : tokens.surface,
              color: on ? '#FFFFFF' : tokens.ink,
              transition: 'background 0.12s ease',
            }}>{label}</button>
        );
      })}
    </div>
  );
}
